var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.544145,
    y: 0.538285,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    fill: "#020407",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.544145,
    y: 0.538285,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint0_linear_706_70383)",
    strokeWidth: 1.07657
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.544145,
    y: 0.538285,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint1_linear_706_70383)",
    strokeWidth: 1.07657
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_70383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4465 28.6367H46.8987L44.94 25.6802C44.2008 24.5715 42.9074 23.9062 41.5769 23.9062H33.4465C32.1161 23.9062 30.8226 24.5715 30.0835 25.6802L28.1248 28.6367H24.5769C22.3226 28.6367 20.5117 30.4476 20.5117 32.7019V47.041C20.5117 49.2954 22.3226 51.1062 24.5769 51.1062H50.4465C52.7008 51.1062 54.5117 49.2954 54.5117 47.041V32.7019C54.5117 30.4476 52.7008 28.6367 50.4465 28.6367ZM37.5117 47.7802C32.4487 47.7802 28.3465 43.678 28.3465 38.6149C28.3465 33.5519 32.4487 29.4867 37.5117 29.4867C42.5748 29.4867 46.6769 33.5889 46.6769 38.6519C46.6769 43.678 42.5748 47.7802 37.5117 47.7802ZM49.9291 34.3649C49.8922 34.3649 49.8552 34.3649 49.7813 34.3649H48.303C47.6378 34.328 47.1204 33.7736 47.1574 33.1084C47.1943 32.4802 47.6748 31.9997 48.303 31.9628H49.7813C50.4465 31.9258 51.0008 32.4432 51.0378 33.1084C51.0748 33.7736 50.5943 34.328 49.9291 34.3649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5121 33.5518C34.7034 33.5518 32.4121 35.8431 32.4121 38.6518C32.4121 41.4605 34.7034 43.7148 37.5121 43.7148C40.3208 43.7148 42.6121 41.4235 42.6121 38.6148C42.6121 35.8061 40.3208 33.5518 37.5121 33.5518Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_70383",
    x1: -8.16079,
    y1: 4.23456,
    x2: 74.7156,
    y2: 75.0122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_70383",
    x1: 89.839,
    y1: 91.9504,
    x2: 2.72807,
    y2: 30.2469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_70383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(20.5117 20.5059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.e36540dd2cb623e496a28bca83a1dcfd.svg";
export { ForwardRef as ReactComponent };